module.exports = __webpack_public_path__ + "img/m_ddqr.9536be3c.png";